import styled from "styled-components";

export const StyledVerticalMatch = styled.div``;

export const StyledVerticalMatchExplainerBar = styled.div`
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const StyledVerticalMatchTileWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  position: relative;
  min-height: 44px;

  .mls-c-vertical-match-time {
    position: absolute;
    left: 0;
  }

  .mls-c-match-tile {
  }

  .mls-c-vertica-match-broadcaster {
    position: absolute;
    right: 0;
  }

  .mls-c-club__picture,
  picture {
    width: 28px;
  }

  .mls-c-club.--home {
    .mls-c-club__name {
      position: relative;
    }
  }

  .mls-c-club.--away {
    .mls-c-club__name {
      position: relative;
    }
  }

`;
